import { LoadingButton } from '@mui/lab';
import { debounce } from '@mui/material';
import { Stack } from '@mui/system';
import React, { useRef, useState } from 'react';
import { SearchContractorInGus, ValidateNIP } from '../../engine/baseApiClient';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import ContractorSearchTextField from './contractorSearchTextField';
import ToastMessage from '../../components/toastMessage';
import MDBox from 'components/MDBox';
import { Input } from 'components/ui';
import MDTypography from 'components/MDTypography';
import BillzTypographyHelptext from '../BillzTypographies/BillzTypographyHelptext';

import * as Styled from './nipGusComponent.styles';

export default function NipGusComponent(props) {
  const id = props.id ?? '';
  const width = props.width ?? 400;
  const searchEnabled = props.searchEnabled ?? false;
  const onContractorDataSet = props.onContractorDataSet;
  const onValidationChanged = props.onValidationChanged;
  const onValueChanged = props.onValueChanged;
  const value = props.value;
  const searchFieldLabel = props.searchFieldLabel;
  const searchHelpText = props.searchHelpText ?? '';

  const [displayGusState, setDisplayGusState] = useState(''); // '' or 'none'
  const [fetchingGus, setFetchingGus] = React.useState(false);

  const [outerError, setOuterError] = useState(props.error);
  const [innerError, setInnerError] = useState(true);

  const [gusButtonDisabled, setGusButtonDisabled] = useState(true);

  const firstUpdate = useRef(true);

  // #region Toasts

  const [openGusSuccessToast, setOpenGusSuccessToast] = React.useState(false);
  const [openGusErrorToast, setOpenGusErrorToast] = React.useState(false);
  const [openGusInfoToast, setOpenGusInfoToast] = React.useState(false);

  // #endregion

  const searchContractorInGus = async (e) => {
    setFetchingGus(true);
    if (value != '') {
      try {
        const searchResult = await SearchContractorInGus(value);

        if (searchResult.status !== 500) {
          onContractorDataSet(e, searchResult, null);
          setOpenGusSuccessToast(true);
        } else {
          setOpenGusErrorToast(true);
        }
      } catch (err) {
        setOpenGusErrorToast(true);
        console.log(err);
      }
    } else {
      setOpenGusInfoToast(true);
    }
    setFetchingGus(false);
  };

  const isError = (obj) => {
    return obj === false;
  };

  const isCorrect = (obj) => {
    return obj === true;
  };

  const throttledNipValidation = React.useMemo(
    () =>
      debounce((value) => {
        async function validateNip(value) {
          const result = (await ValidateNIP(value, 'PL'))?.result ?? true;
          setGusButtonDisabled(!result);
          onValidationChanged(result);
          if (!searchEnabled) {
            console.log(result);
            setInnerError(result);
          } else {
            setInnerError(true);
          }
        }
        validateNip(value);
      }, 250),
    [],
  );

  React.useEffect(() => {
    throttledNipValidation(value);
  }, [value]);

  React.useEffect(() => {
    setOuterError(props.error);
  }, [props.error]);

  return (
    <MDBox style={{ width: '100%' }}>
      <ToastMessage
        open={openGusSuccessToast}
        onClose={() => setOpenGusSuccessToast(false)}
        severity="success"
        message="Pobrano dane z GUS"
      />
      <ToastMessage
        open={openGusErrorToast}
        onClose={() => setOpenGusErrorToast(false)}
        severity="error"
        message="Nie udało się pobrać danych z GUS"
      />
      <ToastMessage
        open={openGusInfoToast}
        onClose={() => setOpenGusInfoToast(false)}
        severity="info"
        message="Wprowadź NIP aby móc wyszukać kontrahenta"
      />

      <Stack direction="row" spacing={1} justifyContent="space-between" alignItems="flex-start">
        {!searchEnabled ? (
          <Input
            onChange={onValueChanged}
            value={value}
            label="NIP *"
            error={isCorrect(outerError) ? "" : isError(outerError) ? "Niepoprawny NIP" : isError(innerError) ? "Niepoprawny NIP" : ""}
            sx={{ flex: 1 }}
            onKeyDown= {(e) => {
              if (e.key === '-') {
                e.preventDefault();
              }
            }}
          />
        ) : (
          <Stack direction="column" sx={{ flex: 1 }}>
            <ContractorSearchTextField
              id={id + '-searchfield'}
              label={searchFieldLabel}
              value={value}
              error={outerError}
              onContractorDataSet={onContractorDataSet}
              onValueChanged={onValueChanged}
            />
            {outerError === false && (<Styled.Label>Niepoprawny NIP</Styled.Label>)}
            <BillzTypographyHelptext>
              {searchHelpText}
            </BillzTypographyHelptext>
          </Stack>
        )}
        <LoadingButton
          id={id + '-gus-button'}
          variant="contained"
          color="text"
          sx={{ display: displayGusState }}
          title="Pobierz dane z GUS"
          disabled={gusButtonDisabled}
          onClick={(event) => {
            searchContractorInGus(event);
          }}
          loading={fetchingGus}
        >
          <CloudDownloadIcon color="info" />
          &nbsp;
          <MDTypography variant="button" color="text">
            <span style={{ color: '#344767', fontWeight: 500 }}>GUS</span>
          </MDTypography>
        </LoadingButton>
      </Stack>
    </MDBox>
  );
}
